import { InternalMovement } from 'components/employee-analytics/analytic-item/InternalMovement'
import moment from 'moment'
import { useState, useEffect } from 'react'
import { useFetch } from 'services/useFetch'
import { API_EMPLOYEE_ANALYTICS } from 'services/apiEmployeeAnalytics'
import { getYears } from 'utils/utils'

const INITIAL_FILTER = {
    year: moment().get('year'),
    company_ids: [],
    department_ids: [],
    division_ids: [],
    sub_division_ids: [],
}

const InternalMovementContainer = () => {
    const { fetching: getInternalMovement, isLoading } = useFetch(API_EMPLOYEE_ANALYTICS.INTERNAL_MOVEMENT)
    const [internalMovementData, setInternalMovementData] = useState([])
    const [filter, setFilter] = useState(INITIAL_FILTER)

    const styleBar = (key) => {
        switch (key) {
            case 'promotion':
                return { bgColor: 'bg-blue-500', textColor: 'text-blue-500' }
            case 'rotation':
                return { bgColor: 'bg-cyan-400', textColor: 'text-cyan-500' }
            case 'transfer':
                return { bgColor: 'bg-cyan-400', textColor: 'text-cyan-500' }
            case 'demotion':
                return { bgColor: 'bg-gray-400', textColor: 'text-gray-400' }
            case 'ad-sow':
                return { bgColor: 'bg-purple-400', textColor: 'text-purple-500' }
            case 'first-contract':
                return { bgColor: 'bg-orange-400', textColor: 'text-orange-400' }
            default:
                return { bgColor: 'bg-slate-500', textColor: 'text-slate-500' }
        }
    }

    useEffect(() => {
        ;(async () => {
            const internalMovement = await getInternalMovement(filter)
            const newData = internalMovement?.data?.detail?.map((item) => ({
                ...item,
                ...styleBar(item?.change_type),
            }))

            setInternalMovementData(newData)
        })()
    }, [filter])

    const onSubmitFilter = (newFilter) => {
        if (JSON.stringify(filter) !== JSON.stringify(newFilter)) {
            setFilter(newFilter)
        }
    }

    const props = {
        data: internalMovementData,
        isLoading,
        filter,
        onSubmitFilter,
        years: getYears(2021),
    }

    return <InternalMovement {...props} />
}

export default InternalMovementContainer
